export default __webpack_public_path__ + "static/media/cta.0a1b4dee.jpg";